import { useState } from "react";
import { C } from "../../../constants/theme";
import { Btn } from "../../ui/Btn";

/* "Materiais extras" — itens auxiliares cadastrados à parte do filamento
   (argola, sacola, embalagem...), com estoque e custo unitário. Filamento
   é outra coisa (FilamentoPicker), sempre visível direto na tela. */
export function MateriaisExtrasSecao({ materiais, materiaisCalc, adicionarMaterial, removerMaterial }) {
  const [matId, setMatId] = useState("");
  const [matQtd, setMatQtd] = useState("1");

  if (materiais.length === 0) {
    return <div style={{ color: C.muted, fontSize: 12.5 }}>Cadastre um material extra na aba Materiais primeiro.</div>;
  }

  return (
    <div>
      <div style={{ display: "flex", gap: 8, alignItems: "flex-end", flexWrap: "wrap" }}>
        <select value={matId} onChange={e => setMatId(e.target.value)} style={{ flex: 1, minWidth: 0, background: C.panel, border: "1px solid " + C.border, borderRadius: 8, color: C.text, padding: "8px 12px", fontSize: 13, outline: "none" }}>
          <option value="">Selecione...</option>
          {materiais.map(m => <option key={m.id} value={m.id}>{m.nome} — R${parseFloat(m.custo_unitario||0).toFixed(2)}/{m.unidade}</option>)}
        </select>
        <input type="number" value={matQtd} onChange={e => setMatQtd(e.target.value)} style={{ width: 60, background: C.panel, border: "1px solid " + C.border, borderRadius: 8, color: C.text, padding: "8px 10px", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
        <Btn small color="#e879f9" onClick={() => { if (matId) { adicionarMaterial(matId, matQtd); setMatId(""); setMatQtd("1"); } }}>➕</Btn>
      </div>
      {materiaisCalc.length > 0 && (
        <div style={{ marginTop: 10, display: "flex", flexWrap: "wrap", gap: 6 }}>
          {materiaisCalc.map(m => (
            <div key={m.id} style={{ background: C.card, border: "1px solid #e879f944", borderRadius: 8, padding: "4px 10px", display: "flex", gap: 8, alignItems: "center", fontSize: 12 }}>
              <span style={{ color: "#e879f9", fontWeight: 700 }}>{m.qtd} {m.unidade}</span>
              <span style={{ color: C.text }}>{m.nome}</span>
              <button onClick={() => removerMaterial(m.id)} style={{ background: "none", border: "none", color: C.danger, cursor: "pointer", fontSize: 14, padding: 0 }}>✕</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
